import type { Dtos } from "@inrev/common";
import { formatAddress } from "@inrev/common";
import { Option } from "@inrev/core";
import { FC } from "react";
import { formatEmpty } from "../../../../../../utils";

type Report = Dtos.Admin.SuretyAccount.Get.Response["companies"][number]["creditReports"][number];
type Company = Dtos.Admin.SuretyAccount.Get.Response["companies"][number];

type FieldProps = {
	label: string;
	value: Option<string>;
};

const Field: FC<FieldProps> = ({ label, value }) => (
	<div className="flex flex-col gap-1">
		<div className="text-[11px] font-medium uppercase tracking-wide text-tertiary">{label}</div>
		<div className="text-[13px] text-primary">{formatEmpty(value)}</div>
	</div>
);

type BusinessIdentityPanelProps = {
	report: Report;
	company: Company;
};

export const BusinessIdentityPanel: FC<BusinessIdentityPanelProps> = ({ report, company }) => {
	const profile = report.creditProfile;
	const elements = profile?.experianExecutiveElements;
	const fein = profile?.fein ?? company.fein;
	const bin = profile?.experianBin;
	const year = elements?.yearOfIncorporation;
	const phone = profile?.phone;
	const addrFromReport =
		profile?.address?.street && profile?.address?.city
			? formatAddress({
					street: profile.address.street,
					city: profile.address.city,
					state: profile.address.state ?? undefined,
					zip: profile.address.zip ?? undefined,
				})
			: null;
	const addressLine = addrFromReport ?? formatAddress(company.address);

	return (
		<div
			className="space-y-3 border-b border-bc-default pb-5"
			data-amp-mask
			data-testid="company_credit_business_identity_panel"
		>
			<h3 className="text-[15px] font-medium text-primary">Business Identity</h3>
			<div className="flex flex-col gap-3">
				<div className="grid grid-cols-2 gap-x-8 gap-y-3 md:grid-cols-4">
					<Field label="FEIN" value={fein} />
					<Field label="Experian BIN" value={bin} />
					<Field label="Year Established" value={year} />
					<Field label="Phone" value={phone} />
				</div>
				<Field label="Address" value={addressLine} />
			</div>
		</div>
	);
};
